import React from 'react';
import { IconChevronDown, IconChevronUp } from '@noths/polaris-client-ribbons-design-system';

import * as styles from './LinksHeading.styles';

interface LinksHeadingProps {
  title: string;
  open?: boolean;
}

export const LinksHeading = ({ title, open }: LinksHeadingProps) => {
  return (
    <h3 css={styles.heading}>
      <span css={styles.title}>{title}</span>
      {open ? <IconChevronUp css={styles.icon} /> : <IconChevronDown css={styles.icon} />}
    </h3>
  );
};
